"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MenuDropdown = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_popper_1 = require("react-popper");
var MenuDropdown_module_scss_1 = __importDefault(require("./MenuDropdown.module.scss"));
var MenuDropdown = function (_a) {
    var children = _a.children, referenceElement = _a.referenceElement, id = _a.id, hideMenuDropdown = _a.hideMenuDropdown, _b = _a.autoHide, autoHide = _b === void 0 ? "on" : _b, _c = _a.align, align = _c === void 0 ? "left" : _c, _d = _a.width, width = _d === void 0 ? "default" : _d;
    var _e = (0, react_1.useState)(null), popperElement = _e[0], setPopperElement = _e[1];
    var _f = (0, react_popper_1.usePopper)(referenceElement, popperElement, {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 6]
                }
            },
            {
                name: "preventOverflow",
                options: {
                    // Gives some room so the menu shadow doesn't get clipped if near the edge of the viewport.
                    padding: 8
                }
            },
        ],
        placement: align === "left" ? "bottom-start" : "bottom-end"
    }), popperStyles = _f.styles, attributes = _f.attributes;
    // This callback handler will not run when autoHide === "off"
    var handleDocumentClickForAutoHide = (0, react_1.useCallback)(function (e) {
        if (popperElement &&
            e.target instanceof Node &&
            !popperElement.contains(e.target) &&
            referenceElement !== e.target &&
            !(referenceElement === null || referenceElement === void 0 ? void 0 : referenceElement.contains(e.target))) {
            hideMenuDropdown();
        }
    }, [popperElement, referenceElement, hideMenuDropdown]);
    var handleDocumentResize = (0, react_1.useCallback)(function () {
        hideMenuDropdown();
    }, [hideMenuDropdown]);
    var handleRootClick = function () {
        if (autoHide === "on") {
            // ie. is not equal to "off" | "outside-click-only"
            hideMenuDropdown();
        }
    };
    (0, react_1.useEffect)(function () {
        window.addEventListener("resize", handleDocumentResize, false);
        return function () {
            window.removeEventListener("resize", handleDocumentResize, false);
        };
    }, [handleDocumentResize]);
    (0, react_1.useEffect)(function () {
        if (autoHide !== "off") {
            document.addEventListener("click", handleDocumentClickForAutoHide, true);
        }
        return function () {
            if (autoHide !== "off") {
                document.removeEventListener("click", handleDocumentClickForAutoHide, true);
            }
        };
    }, [autoHide, handleDocumentClickForAutoHide]);
    return (
    // Disabling these because we don't want this to be keyboard focusable.
    // Esc keypress should be used instead for the same behaviour (hasn't been implemented here yet)
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    react_1["default"].createElement("div", __assign({ id: id, ref: setPopperElement }, attributes.popper, { style: popperStyles.popper, className: (0, classnames_1["default"])(MenuDropdown_module_scss_1["default"].menuContainer, width == "default" && MenuDropdown_module_scss_1["default"].defaultWidth), onClick: handleRootClick }), children));
};
exports.MenuDropdown = MenuDropdown;
exports.MenuDropdown.displayName = "MenuDropdown";
//# sourceMappingURL=MenuDropdown.js.map